"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var TITLES = {
  vocab: 'Vocab',
  gender: 'Genders',
  plural: 'Plurals',
  synonym: 'Synonyms',
  conjugation: 'Conjugations',
  number: 'Numbers',
  "case": 'Cases'
};
var VocabDecksWrapper = function VocabDecksWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _this.onClick = function (type) {
        if (type === 'vocab' && _this.vocabDeckDisabled || type === 'gender' && _this.genderDeckDisabled || type === 'plural' && _this.pluralDeckDisabled || type === 'synonym' && _this.synonymDeckDisabled || type === 'conjugation' && _this.conjugationDeckDisabled || type === 'number' && _this.numberDeckDisabled || type === 'case' && _this.caseDeckDisabled) {
          _state.AppUI.routeStore.routeToNamed('memberships.index');
        } else {
          _state.AppUI.onSetVocabModal(type);
        }
      };
      _state.AppUI.createEvent('vocab - view trainers');
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "genderDeckAvailableCount",
      get: function get() {
        return _state.AppUI.user.isMember ? Infinity : _state.AppUI.user.freeGenderDecksAvailableCount;
      }
    }, {
      key: "pluralDeckAvailableCount",
      get: function get() {
        return _state.AppUI.user.isMember ? Infinity : _state.AppUI.user.freePluralDecksAvailableCount;
      }
    }, {
      key: "conjugationDeckAvailableCount",
      get: function get() {
        return _state.AppUI.user.isMember ? Infinity : _state.AppUI.user.freeConjugationDecksAvailableCount;
      }
    }, {
      key: "synonymDeckAvailableCount",
      get: function get() {
        return _state.AppUI.user.isMember ? Infinity : _state.AppUI.user.freeSynonymDecksAvailableCount;
      }
    }, {
      key: "numberDeckAvailableCount",
      get: function get() {
        return _state.AppUI.user.isMember ? Infinity : _state.AppUI.user.freeNumberDecksAvailableCount;
      }
    }, {
      key: "vocabDeckAvailableCount",
      get: function get() {
        return _state.AppUI.user.isMember ? Infinity : _state.AppUI.user.freeVocabDecksAvailableCount;
      }
    }, {
      key: "caseDeckAvailableCount",
      get: function get() {
        return _state.AppUI.user.isMember ? Infinity : _state.AppUI.user.freeCaseDecksAvailableCount;
      }
    }, {
      key: "genderDeckDisabled",
      get: function get() {
        return this.genderDeckAvailableCount <= 0;
      }
    }, {
      key: "pluralDeckDisabled",
      get: function get() {
        return this.pluralDeckAvailableCount <= 0;
      }
    }, {
      key: "conjugationDeckDisabled",
      get: function get() {
        return this.conjugationDeckAvailableCount <= 0;
      }
    }, {
      key: "synonymDeckDisabled",
      get: function get() {
        return this.synonymDeckAvailableCount <= 0;
      }
    }, {
      key: "vocabDeckDisabled",
      get: function get() {
        return this.vocabDeckAvailableCount <= 0;
      }
    }, {
      key: "numberDeckDisabled",
      get: function get() {
        return this.numberDeckAvailableCount <= 0;
      }
    }, {
      key: "caseDeckDisabled",
      get: function get() {
        return this.caseDeckAvailableCount <= 0;
      }
    }, {
      key: "modalTitle",
      get: function get() {
        return "".concat((0, _lodash.capitalize)(_state.AppUI.showVocabModal), " Options");
      }
    }, {
      key: "progress",
      get: function get() {
        var _AppUI$targetLanguage, _AppUI$targetLanguage2, _AppUI$targetLanguage3, _AppUI$targetLanguage4, _AppUI$targetLanguage5, _AppUI$targetLanguage6, _AppUI$targetLanguage7, _AppUI$targetLanguage8, _AppUI$targetLanguage9, _AppUI$targetLanguage0, _AppUI$targetLanguage1, _AppUI$targetLanguage10, _AppUI$targetLanguage11, _AppUI$targetLanguage12;
        return {
          vocab: {
            current: (_AppUI$targetLanguage = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage === void 0 ? void 0 : _AppUI$targetLanguage.vocabTrainerWordsSeenCount,
            total: (_AppUI$targetLanguage2 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage2 === void 0 ? void 0 : _AppUI$targetLanguage2.vocabTrainerWordsCount
          },
          conjugation: {
            current: (_AppUI$targetLanguage3 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage3 === void 0 ? void 0 : _AppUI$targetLanguage3.conjugationCardsSeenCount,
            total: (_AppUI$targetLanguage4 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage4 === void 0 ? void 0 : _AppUI$targetLanguage4.vocabTrainerVerbsCount
          },
          gender: {
            current: (_AppUI$targetLanguage5 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage5 === void 0 ? void 0 : _AppUI$targetLanguage5.genderCardsSeenCount,
            total: (_AppUI$targetLanguage6 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage6 === void 0 ? void 0 : _AppUI$targetLanguage6.vocabTrainerNounsCount
          },
          plural: {
            current: (_AppUI$targetLanguage7 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage7 === void 0 ? void 0 : _AppUI$targetLanguage7.pluralCardsSeenCount,
            total: (_AppUI$targetLanguage8 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage8 === void 0 ? void 0 : _AppUI$targetLanguage8.vocabTrainerNounsCount
          },
          synonym: {
            current: (_AppUI$targetLanguage9 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage9 === void 0 ? void 0 : _AppUI$targetLanguage9.synonymCardsSeenCount,
            total: (_AppUI$targetLanguage0 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage0 === void 0 ? void 0 : _AppUI$targetLanguage0.vocabTrainerSynonymsCount
          },
          number: {
            current: (_AppUI$targetLanguage1 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage1 === void 0 ? void 0 : _AppUI$targetLanguage1.numberCardsSeenCount,
            total: (_AppUI$targetLanguage10 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage10 === void 0 ? void 0 : _AppUI$targetLanguage10.vocabTrainerNumbersCount
          },
          "case": {
            current: (_AppUI$targetLanguage11 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage11 === void 0 ? void 0 : _AppUI$targetLanguage11.caseCardsSeenCount,
            total: (_AppUI$targetLanguage12 = _state.AppUI.targetLanguage) === null || _AppUI$targetLanguage12 === void 0 ? void 0 : _AppUI$targetLanguage12.caseTrainerWordAssociationsCount
          }
        };
      }
    }, {
      key: "showNewLabel",
      value: function showNewLabel(type) {
        if (type === 'synonym') {
          var expirationDate = _state.AppUI.layout.isNative ? '2026-08-19T00:00:00' : '2026-08-05T00:00:00';
          return new Date() < new Date(expirationDate) && !_state.AppUI.wasUiElementSeen('synonym-trainer-card-answered');
        }
        return false;
      }
    }, {
      key: "deckConfig",
      get: function get() {
        var _this2 = this;
        var progress = this.progress;
        return _constants.VocabDeckConfig.map(function (config) {
          return _objectSpread(_objectSpread({}, config), {}, {
            disabled: _this2["".concat(config.type, "DeckDisabled")],
            progress: progress[config.type],
            title: config.type === 'gender' && _state.AppUI.targetLanguageId === 'DE' ? 'Der Die Das' : TITLES[config.type],
            showNewLabel: _this2.showNewLabel(config.type)
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onClick: this.onClick,
          titles: TITLES,
          deckConfig: this.deckConfig,
          genderDeckAvailableCount: this.genderDeckAvailableCount,
          conjugationDeckAvailableCount: this.conjugationDeckAvailableCount,
          pluralDeckAvailableCount: this.pluralDeckAvailableCount,
          synonymDeckAvailableCount: this.synonymDeckAvailableCount,
          vocabDeckAvailableCount: this.vocabDeckAvailableCount,
          caseDeckAvailableCount: this.caseDeckAvailableCount,
          genderDeckDisabled: this.genderDeckDisabled,
          conjugationDeckDisabled: this.conjugationDeckDisabled,
          pluralDeckDisabled: this.pluralDeckDisabled,
          synonymDeckDisabled: this.synonymDeckDisabled,
          vocabDeckDisabled: this.vocabDeckDisabled,
          numberDeckDisabled: this.numberDeckDisabled,
          caseDeckDisabled: this.caseDeckDisabled,
          progress: this.progress,
          modalTitle: this.modalTitle
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "genderDeckAvailableCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "genderDeckAvailableCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pluralDeckAvailableCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pluralDeckAvailableCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "conjugationDeckAvailableCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "conjugationDeckAvailableCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymDeckAvailableCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymDeckAvailableCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numberDeckAvailableCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numberDeckAvailableCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabDeckAvailableCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabDeckAvailableCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "caseDeckAvailableCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "caseDeckAvailableCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "genderDeckDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "genderDeckDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pluralDeckDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pluralDeckDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "conjugationDeckDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "conjugationDeckDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "synonymDeckDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "synonymDeckDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "vocabDeckDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "vocabDeckDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numberDeckDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numberDeckDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "caseDeckDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "caseDeckDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "modalTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "modalTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "progress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "progress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckConfig", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckConfig"), _class2.prototype), _class2)) || _class;
};
VocabDecksWrapper.displayName = 'VocabDecksWrapper';
var _default = exports["default"] = VocabDecksWrapper;